"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _mediaDetailContext = require("../media-detail-context");

var _media = require("../../../util/media");

var _alloyReactIcon = require("@adsk/alloy-react-icon");

var _alloyReactDivider = _interopRequireDefault(require("@adsk/alloy-react-divider"));

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _Nav = _interopRequireDefault(require("./Nav"));

var _Zoom = _interopRequireDefault(require("./Zoom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ToolbarContainer = _styledComponents.default.div`
  width: calc(100% - 38px);
  height: 42px;
  position: absolute;
  bottom: 50px;
  display: flex;
  justify-content: center;
`;
const Toolbar = _styledComponents.default.div`
  background-color: ${_alloyReactTheme.default.colors.black};
  color: ${_alloyReactTheme.default.colors.white};
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;
const StyledArrowMinimizeIcon = (0, _styledComponents.default)(_alloyReactIcon.ArrowMinimizeIcon)`
  cursor: pointer;
  &:hover {
    color: ${_alloyReactTheme.default.colors.adskBlue500};
  }
`;
const StyledExpandIcon = (0, _styledComponents.default)(_alloyReactIcon.ExpandIcon)`
  cursor: pointer;
  &:hover {
    color: ${_alloyReactTheme.default.colors.adskBlue500};
  }
`;

const Divider = () => /*#__PURE__*/_react.default.createElement("div", {
  style: {
    height: 34,
    padding: "20px"
  }
}, /*#__PURE__*/_react.default.createElement(_alloyReactDivider.default, {
  variant: _alloyReactDivider.default.VARIANTS.VERTICAL,
  color: _alloyReactTheme.default.colors.charcoal400
}));

const ToolbarView = ({
  fullscreen,
  setFullscreen
}) => {
  const {
    state: {
      media,
      photoNav
    }
  } = (0, _mediaDetailContext.useMedia)();
  const ToolbarIcon = fullscreen ? StyledArrowMinimizeIcon : StyledExpandIcon;
  return /*#__PURE__*/_react.default.createElement(ToolbarContainer, null, /*#__PURE__*/_react.default.createElement(Toolbar, null, photoNav && /*#__PURE__*/_react.default.createElement(_Nav.default, null), media.imageType === _media.IMAGE_TYPES.NORMAL && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(_Zoom.default, null), /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(ToolbarIcon, {
    size: 20,
    color: _alloyReactTheme.default.colors.white,
    onClick: setFullscreen
  }))));
};

var _default = ToolbarView;
exports.default = _default;